(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Arriving from a link on the site to a filtered collection URL (e.g. a
   * campaign banner linking to ?filter.p.vendor=Swanson): land on the product
   * grid instead of the top of the page. Filtering from the filter UI itself
   * is done without a page load, so it is never affected, and neither are
   * direct visits, reloads or back/forward navigation.
   */
  (() => {
    if (url.hash) return;
    if (![...url.searchParams.keys()].some((key) => key.startsWith('filter.'))) return;

    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type !== 'navigate') return;

    try {
      if (!document.referrer || new URL(document.referrer).origin !== window.location.origin) return;
    } catch (_error) {
      return;
    }

    let userScrolled = false;
    const markScrolled = () => {
      userScrolled = true;
    };
    ['wheel', 'touchstart', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, markScrolled, { once: true, passive: true });
    });

    const scrollToGrid = () => {
      if (userScrolled) return;

      const grid = document.querySelector('.product-grid-container');
      if (!grid) return;

      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      const offset = (Number.isFinite(headerHeight) ? headerHeight : 70) + 12;
      window.scrollTo({ top: grid.getBoundingClientRect().top + window.scrollY - offset, behavior: 'instant' });
    };

    document.addEventListener('DOMContentLoaded', scrollToGrid, { once: true });
    // Images above the grid can shift the layout once loaded, so re-aim once more.
    window.addEventListener('load', scrollToGrid, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
